<template>
  <!-- 组合列表 -->
  <div class="combin-list">
    <el-form
      :inline="true"
      :model="formInline"
      label-position="left"
      class="demo-form-inline"
    >
      <el-form-item label="组合处理编号：">
        <el-input
          v-model="formInline.packCode"
          placeholder="输入组合处理编号" 
          @keydown.native.enter="onSubmit"
        ></el-input>
      </el-form-item>
      <el-form-item label="组合状态：">
        <el-select v-model="formInline.status" placeholder="全部">
          <el-option label="请选择" :value="undefined"></el-option>
          <el-option label="待处理" :value="0"></el-option>
          <el-option label="组合中" :value="1"></el-option>
          <el-option label="已完成" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="订单号：">
        <el-input
          v-model="formInline.platformOrderNo"
          placeholder="输入订单号" 
          @keydown.native.enter="onSubmit"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">查询</el-button>
        <el-button @click="restSubmit">重置</el-button>
      </el-form-item>
    </el-form>
    <WmsTable
      :columns="combinColumns"
      @pageChange="pageChangeCall"
      :dataSource="dataSource" :isPagination="query" 
      isExpanded_hidden
      :hasHeader="false"
    >
      <div slot="productImg" slot-scope="{ record }">
        <ImgPreviews :images="[record.productImg]"></ImgPreviews>
      </div>
      <template #action="{ record }">
        <a @click="getDetail(record)">详情</a>
      </template>
      <div slot="expandedRender" slot-scope="{ record }">
        <el-table :data="record.packItems" :border="true">
          <el-table-column prop="productImg" label="图片">
            <template slot-scope="scope">
              <ImgPreviews :images="[scope.row.productImg]"></ImgPreviews>
            </template>
          </el-table-column>
          <el-table-column
            prop="productName"
            label="商品名称"
          ></el-table-column>
          <el-table-column prop="shopProductSku" label="商品sku"></el-table-column>
          <el-table-column prop="productProp" label="规格"></el-table-column>
          <el-table-column prop="unitAmount" label="单组数量"></el-table-column>
          <el-table-column prop="checkingShelvedAmount" label="质检上架数"></el-table-column>
          <el-table-column prop="checkedShelvedAmount" label="成品上架数"></el-table-column>
        </el-table>
      </div>
    </WmsTable>

    <el-dialog title="组合商品详情" :visible.sync="dialogVisible">
      <detail ref="detail" @close="dialogVisible = false"></detail>
    </el-dialog>
  </div>
</template>
<script>
import WmsTable from "@/components/WmsTable";
import { combinColumns, goodsColumns, detailColumns } from "./combinTable";
import { Table } from "ant-design-vue";
import { packTaskPage, getCombinationListApi } from "@/apis/combination";
import ImgPreviews from "@/components/ImgPreviews";
import detail from "./combinListDetail";
export default {
  title: "组合列表",
  name: "CombinList",
  components: {
    WmsTable,
    [Table.name]: Table,
    ImgPreviews,
    detail,
  },
  data() {
    return {
      combinColumns,
      goodsColumns,
      detailColumns,
      formInline: {},
      dataSource: [],
      params: {},
      query: {
        pageSize: 10,
        current: 1,
        total: 0,
      },
      dialogVisible: false,
    };
  },
  methods: {
    getList() {
      let params = {
        pageSize: this.query.pageSize,
        pageNum: this.query.current,
        ...this.formInline,
      };
      getCombinationListApi(params).then(({ code, data }) => {
        if (code == 0) {
          // data.records.forEach((item) => {
          //   item.hasPicked = 0;
          //   if (item.packRecords) {
          //     item.packRecords.forEach((item_son) => {
          //       item.hasPicked += item_son.amount;
          //       item_son.printNum = ''
          //     });
          //   }
          // });
          this.dataSource = data.records;
          this.query.total = data.total;
        }
      });
    },
    pageChangeCall(payload) {
      const { current, pageSize } = payload;
      this.query.current = current;
      this.query.pageSize = pageSize;
      this.getList();},
    onSubmit() {
      this.query.current = 1
      this.getList();
    },
    restSubmit() {
      this.formInline = {}
      this.query.current = 1
      this.query.total = 0
      this.getList();
    },
    getDetail(record) {
      this.dialogVisible = true;
      console.log(record.packRecords)
      this.$nextTick((_) => {
        this.$refs.detail.detail = record.packRecords || [];
        // this.$refs.detail.detail[0].printNum = 1;
      });
      // this.$bus.$emit("combinDetailClick");
    },
  },
  created() {
    this.getList();
  },
};
</script>
<style lang="less" scoped>
.demo-form-inline {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
}
</style>
